import { connect } from 'react-redux';
import { collectFave } from '../../CollectionPanel/redux/actionCreators';
import { getIsFavourite } from '../../CollectionPanel/redux/selectors';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { getCurrentUser } from '../../publicSession/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    currentUser: getCurrentUser(state),
    isFavourite: getIsFavourite(state, ownProps.deviation),
}); };
var mapDispatchToProps = {
    onAddToCollection: collectFave,
    addNotification: addNotificationToQueue,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export default connector;
//# sourceMappingURL=FaveNotification.container.js.map